import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {GlobalService} from 'app/global/global.service';
import {ContractControlService, ICCGetGroupsManagers, ICCGetUsersManagers} from 'app/main/pages/contract-control/contract-control.service';
import {take} from 'rxjs/operators';
import {UserSettingsFacade} from '../../../../../../store/user-settings.facade';
import {IAutoFillUploadFile} from '../create-cc-by-ai-form/ai-cc-import.service';
import {IaiProcessedData} from '../iai-processed-data.interface';

export interface ICCGroupManagerDDLItem extends ICCGetGroupsManagers{
    isGroup: boolean
}

@Component({
  selector: 'app-managers',
  templateUrl: './managers.component.html',
  styleUrl: './managers.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ManagersComponent implements OnInit, IaiProcessedData{
  @Input() mainFormGroup: FormGroup;
  @Input() aiProcessedData: IAutoFillUploadFile;
    
  public managers: ICCGetUsersManagers[] = [];
  public keyword: string = 'name';
  public loading: boolean = false;
  public managersAndGroups: Array<ICCGroupManagerDDLItem | ICCGetUsersManagers> = [];

  constructor(
    private contractControlService: ContractControlService,
    private globalService: GlobalService,
    private _formBuilder: FormBuilder, 
    private _userSettingsFacade$: UserSettingsFacade
  ) { }

  ngOnInit(): void {
      if(this.aiProcessedData){
          this.initializeWithAIProcessedData(this.aiProcessedData);
      }
  }

  /**
   * Get options control
   */
  get managersControl() {
    return this.mainFormGroup.controls["managers"] as FormArray;
  }




  /**
   * Remove Category
   * @param index 
   */
  removeManager(index: number) {
    this.managersControl.removeAt(index);
    this.managersControl.markAsDirty();
  }


  /**
   * Search managers
   * @param q 
   * @returns managers
   */
  searchManagers(q: string = '') {
    if (q == '') return;
    
    this.loading = true;
    this.contractControlService.getManagers(q)
        .subscribe({
            next:(response) => {
                this.loading = false;
                this.managersAndGroups = response;
            },
            error: () => {
                this.loading = false;
                this.managersAndGroups = [];
            }
        });
  }



  inputCleared() {
    this.managersAndGroups = [];
  }




  /**
   * Select Manager from demo array
   * @param $item 
   * @returns 
   */
  async selectEvent($item: ICCGroupManagerDDLItem | ICCGetUsersManagers) {
    const exists = this.userAlreadyExists($item.id);
    if (exists) {
      this.globalService.toastrError('Manager already exists');
      return;
    }
    $item = {...$item, ...{sectionable_id: $item.id, type: this.getDDLItemTypeType($item)}}
    const managerControl = this._formBuilder.group($item);
    this.managersControl.push(managerControl);
    this.managersControl.markAsDirty();
  }


    initializeWithAIProcessedData(aiProcessedData: IAutoFillUploadFile): void {
      if(this.managersControl.dirty || aiProcessedData == null){
          return;
      }

        this._userSettingsFacade$._userSettings$
            .pipe(take(1))
            .subscribe((userSettings) => {
                const exist = this.userAlreadyExists(userSettings.id);
                if (!exist){
                    const newManager: ICCGetUsersManagers = {
                        id: userSettings.id,
                        name: userSettings.name,
                        phone: userSettings.phone,
                        email: userSettings.email,
                        profile_image:null,
                        signature: userSettings.signature,
                        status:userSettings.status,
                        tenant_owner: userSettings.tenant_owner,
                        sectionable_id: userSettings.id,
                        type:'users'
                    } as ICCGetUsersManagers & {type: string};

                    this.addUserToList(newManager);
                }
            });
    }

    private getDDLItemTypeType($item: ICCGroupManagerDDLItem | ICCGetUsersManagers): 'groups' | 'users' {
        return Object.prototype.hasOwnProperty.call($item, 'isGroup')
        && (<ICCGroupManagerDDLItem>$item).isGroup
            ? 'groups'
            : 'users';
    }
    
    private userAlreadyExists(userId: number): boolean {
        return (this.managersControl?.value ?? []).some(x => x.id === userId);
    }
    
    private addUserToList($item:ICCGroupManagerDDLItem | ICCGetUsersManagers){
        const managerControl = this._formBuilder.group($item);
        this.managersControl.push(managerControl);
    }

}
